import routerOptions0 from "/Users/kevin/Coding-Projects/Injective-Relayer/base-dex/versions/2023_11_18/wavely/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}